import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
import styled from 'styled-components'
import { translate } from 'loankeeper-common/helpers'

import WithRerenderInterval from '../WithRerenderInterval'

const StyledContainer = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
`

const StyledParagraph = styled.p`
  margin-bottom: 0px;
  text-align: center;
  background-color: red;
  padding: 3px;
  color: white;
  border: 1px solid white;
`

const ClientWarningMessages: FC<{ FormName: string }> = ({ FormName }) => {
  const valueSelector = formValueSelector(FormName)

  const fillClientDetailsWarning: boolean = useSelector((state) => valueSelector(state, 'fillClientDetailsWarning'))
  const uploadClientIDCopyWarning: boolean = useSelector((state) => valueSelector(state, 'uploadClientIDCopyWarning'))

  if (fillClientDetailsWarning || uploadClientIDCopyWarning) {
    return (
      <WithRerenderInterval>
        <StyledContainer>
          {fillClientDetailsWarning && (
            <StyledParagraph>{translate('frm_acc_conv_add-pan_nbg_fill_details')}</StyledParagraph>
          )}

          {uploadClientIDCopyWarning && (
            <StyledParagraph style={{ marginTop: 2 }}>{translate('frm_acc_conv_add-pan_nbg_idcopy')}</StyledParagraph>
          )}
        </StyledContainer>
      </WithRerenderInterval>
    )
  }

  return null
}

export default ClientWarningMessages
